<template>
    <div class="igc-label"
        :style="{ 'background': mColor(7) }">
        <sui-scroll class="ig--detail"
            :style="{ 'background': mBackground(17, 'right') }">
            <sui-image class="ig--poster"
                :src="`${ imagePath }/poster/${ label }.png`"></sui-image>
            <div class="ig--info">
                <div class="ig--name"
                    :style="{ 'color': mColor(1) }">{{ knowledge.name }}</div>
                <div class="ig--desc"
                    :style="{ 'color': mColor(3) }">{{ knowledge.desc | changeEnter }}</div>
                <div class="ig--link">
                    <div class="item"
                        v-for="item in knowledge.url"
                        :key="item.url"
                        :style="{ 'color': mColor(4), 'border-color': mColor(4) }"
                        @click="to(item.url)">{{ item.name }} ></div>
                </div>
            </div>
        </sui-scroll>
        <div class="ig--playbook"
            v-if="knowledge.items">
            <div class="ig--tab"
                :style="{ 'background': mBackground(17, 'bottom') }">
                <div class="ig--item"
                    v-for="(item, index) in knowledge.items"
                    :key="item.name"
                    :style="{ 'color': tab == index ? mColor(14) : mColor(15) }"
                    @touchstart.stop="toggleTab(item,index)">
                    <div>{{ item.name }}</div>
                    <div class="ig--active"
                        v-show="tab == index"
                        :style="{ 'background-color': mColor(14) }"></div>
                </div>
            </div>

            <!-- #region 精品攻略 -->
            <sui-scroll class="ig--list"
                v-show="knowledge.items[tab] && knowledge.items[tab].type == 1"
                @reachEnd="getV4List">
                <div class="ig--title">
                    <div
                        :style="{ 'color': mColor(3) }">共有 {{ total }} 条精品攻略</div>
                    <!-- <div class="ig--sort"
                        :style="{ 'color': igmColor['4'] }">
                        <div>热门排序</div>
                        <sui-icon class="ig--icon"
                            name="sort"
                            :fill="igmColor['4']"></sui-icon>
                    </div> -->
                </div>
                <igc-item-playbook
                    v-for="item in v4List"
                    :key="item.iId"
                    :playbook="item"></igc-item-playbook>
                <sui-load
                    :color="mColor(3)"
                    :more="more"></sui-load>
            </sui-scroll>
            <!-- #endregion -->

            <!-- #region 短攻略 -->
            <sui-scroll class="ig--list"
                v-show="knowledge.items[tab] && knowledge.items[tab].type == 2"
                @reachEnd="getUGCList">
                <div class="ig--title">
                    <div
                        :style="{ 'color': mColor(3) }">共有 {{ totalUGC }} 条短攻略</div>
                    <div class="ig--sort"
                        :style="{ 'color': mColor(4) }"
                        @touchstart="sortUGC = sortUGC == 1 ? 2 : 1">
                        <div>{{ sortUGC == 1 ? '时间' : '热门' }}排序</div>
                        <sui-icon class="ig--icon"
                            name="sort"
                            :fill="mColor(4)"></sui-icon>
                    </div>
                </div>
                <igc-item-short
                    v-for="(item, index) in UGCList"
                    :key="item.guide_id"
                    :item="item"
                    :notag="true"
                    @delete-item="deleteMoment(index)"></igc-item-short>
                <sui-load
                    :color="mColor(3)"
                    :more="moreUGC"></sui-load>
            </sui-scroll>
            <!-- #endregion -->

            <!-- #region 链接 -->
            <sui-scroll class="ig--list"
                v-show="knowledge.items[tab] && knowledge.items[tab].type == 3">
                <iframe frameborder="0"  
                    :src="mAddTokenParams(knowledge.items[tab].url)"></iframe>
            </sui-scroll>
            <!-- #endregion -->

        </div>
        <igc-submit-entry
            v-show="knowledge.items && knowledge.items[tab] && knowledge.items[tab].type == 2"
            :id="label"></igc-submit-entry>
    </div>
</template>

<script>
import { requestJsonp, requestV4MixedList } from 'scripts/request'

import mCore from 'scripts/mixins/core'

import IgcItemShort from 'components/item-short/index.vue'
import IgcItemPlaybook from 'components/item-playbook/item-playbook.vue'
import IgcSubmitEntry from 'components/submit/submit_entry.vue'

export default {
    name: 'igc-label',

    mixins: [mCore],

    props: {
        label: {
            type: [Number, String],
            required: true
        },

        tab: {
            type: [Number, String],
            default: 0
        }
    },

    components: {
        IgcItemPlaybook,
        IgcItemShort,
        IgcSubmitEntry
    },

    data() {
        return {
            UGCList: [], // 短攻略
            totalUGC: 0, // 短攻略条数
            sortUGC: 2, // 排序：1（时间排序），2（热门排序）
            v4List: [], // 精品攻略
            total: 0, // 精品攻略条数
            num: 8,
            curIndex: 0,
            busy: false,
            more: true,
            busyUGC: false,
            moreUGC: true,
        }
    },

    watch: {
        'label': {
            handler() {
                this.resetLabels()
                this.knowledge.items.forEach((item) => {
                    if (item.type == 1) {
                        this.getV4List(item.id)
                    }
                    if (item.type == 2) {
                        this.getUGCList()
                    }
                })
            }
        },

        'sortUGC': {
            handler(nv) {
                this.UGCList = []
                this.totalUGC = 0
                this.busyUGC = false
                this.moreUGC = true
                this.getUGCList(nv)
            }
        },

        '$route.query.active': {
            handler(nv) {
                this.curIndex = nv
            }
        }
    },

    filters:{
        changeEnter(v){
            v = v || "";
            return v.replace(/↵/g,'<br>')
        }
    },

    computed: {
        imagePath() {
            return this.$store.getters['global/imagePath']
        },

        knowledge() {
            return this.$store.state.global.knowledgeSpread[this.label] || {}
        }
    },

    created() {
        let self = this
        function init() {
            if (self.knowledge.items) {
                self.knowledge.items.forEach((item,index) => {
                    if(index == self.tab){
                        if (item.type == 1) {
                            self.getV4List(item.id)
                        }
                        if (item.type == 2) {
                            self.getUGCList()
                        }
                    }
                })
                self.curIndex = self.tab
            } else {
                requestAnimationFrame(init)
            }
        }
        requestAnimationFrame(init)
    },

    methods: {
        resetLabels(){
            this.UGCList = []
            this.totalUGC = 0
            this.v4List = []
            this.total = 0
            this.busy = false
            this.more = true
            this.busyUGC = false
            this.moreUGC = true
        },

        toggleTab(item , index) {
            if(this.curIndex == index){
                return 
            }
            this.curIndex = index
            this.resetLabels()
            if(item.type == 1){
                this.getV4List(item.id)
            }
            if(item.type == 2){
                this.getUGCList(null,item.id)
            }
            
            this.$emit('update:tab', index)
        },
        
        getV4List(id = this.label) {
            // #region 正在加载或者无更多内容则不继续请求
            if (this.busy || !this.more) {
                return
            }
            this.busy = true
            // #endregion

            requestV4MixedList({
                limit: this.num,
                start: this.v4List.length,
                tagids: id,
            }).then((result) => {
                const { data = {} } = result
                if (data.status == 0) {
                    this.total = data.data.total
                    let list = data.data && data.data.items ? data.data.items : []
                    this.v4List = this.v4List.concat(list)
                    this.more = Boolean(list.length >= this.num)
                    if (this.mConfig.options.comment) {
                        this.getV4ListCommentNumber(list)
                    }
                } else {
                    this.more = false
                    /*if (this.v4List.length == 0) {
                        this.$toast('暂无内容')
                    }*/
                }
                this.busy = false
            })
        },

        /**
         * 拉取短攻略列表
         * @param {Number} [sort = this.sortUGC] - 排序：1（时间排序），2（热门排序）
         */
        getUGCList(sort = this.sortUGC, id = this.label) {
            sort = sort || this.sortUGC
            // #region 正在加载或者无更多内容则不继续请求
            if (this.busyUGC || !this.moreUGC) {
                return
            }
            this.busyUGC = true
            // #endregion

            requestJsonp({
                url: '/interactcenter/query_tiny_guide_by_id.php',
                data: {
                    works_id: id,
                    order_type: sort,
                    start: this.UGCList.length,
                    num: this.num
                }
            }).then(result => {
                if (result.status.toLowerCase() == 'success') {
                    this.totalUGC = result.data && result.data.total ? result.data.total : 0
                    let list = result.data && result.data.guidelist ? result.data.guidelist : []
                    this.UGCList = this.UGCList.concat(list)
                    this.moreUGC = Boolean(list.length >= this.num)
                    if (this.mConfig.options.comment) {
                        this.getUGCListCommentNumber(list)
                    }
                } else {
                    this.moreUGC = false
                    if (this.UGCList.length == 0) {
                        this.$toast('暂无内容')
                    }
                }
                this.busyUGC = false
            })
        },

        /**
         * 批量查询 PGC 评论数
         * @param {Array} list - 需要查询的资源数组
         */
        getV4ListCommentNumber(list) {
            const params = list.map((item) => {
                const date = new Date(item.sIdxTime.replace(/-/g, '/'))
                return `all_mobile,${ date.getFullYear() + (date.getMonth() + 1).toString().padStart(2, '0') },${ item.iId }_ingame`
            })
            requestJsonp({
                url: '/comment/query_source_list_info.php',
                data: {
                    busikey: 'all_mobile',
                    objlist: params.join(';')
                }
            }).then(result => {
                if (result.status.toLowerCase() == 'success') {
                    const list = result.data.stat_list ? result.data.stat_list : []
                    list.forEach((item) => {
                        for (let i = this.v4List.length - 1; i >= 0; i--) {
                            if (this.v4List[i].iId == item.objid.split('_')[0]) {
                                this.$set(this.v4List[i], 'igNum', this.v4List[i].igNum ? Object.assign(this.v4List[i].igNum, {
                                    comment: item.num
                                }): {
                                    comment: item.num
                                })
                                break
                            }
                        }
                    })
                }
            })
        },

        /**
         * 批量查询 UGC 评论数
         * @param {Array} list - 需要查询的资源数组
         */
        getUGCListCommentNumber(list) {
            const params = list.map((item) => {
                const date = new Date(item.addtime * 1000)
                return `all_mobile,${ date.getFullYear() + (date.getMonth() + 1).toString().padStart(2, '0') },${ item.guide_id }_ingame`
            })
            requestJsonp({
                url: '/comment/query_source_list_info.php',
                data: {
                    busikey: 'all_mobile',
                    objlist: params.join(';')
                }
            }).then(result => {
                if (result.status.toLowerCase() == 'success') {
                    const list = result.data.stat_list ? result.data.stat_list : []
                    list.forEach((item) => {
                        for (let i = this.UGCList.length - 1; i >= 0; i--) {
                            if (this.UGCList[i].guide_id == item.objid.split('_')[0]) {
                                this.$set(this.UGCList[i], 'igNum', this.UGCList[i].igNum ? Object.assign(this.UGCList[i].igNum, {
                                    comment: item.num
                                }): {
                                    comment: item.num
                                })
                                break
                            }
                        }
                    })
                }
            })
        },

        /**
         * 删除动态
         * @param {Number} index - 动态索引
         */
        deleteMoment(index) {
            this.UGCList.splice(index, 1)
        },

        /**
         * 外链跳转
         * @param {String} url - 外链 URL
         */
        to(url) {
            if (sessionStorage.tokenParams) {
                url = url.includes('?') ? url + sessionStorage.tokenParams.replace('?', '&') : url + sessionStorage.tokenParams
            }
            location.assign(url)
        }
    }
}
</script>

<style lang="postcss">
.igc-label {
    flex: auto;
    display: flex;
    overflow: hidden;
    @media (orientation: portrait) {
        flex-direction: column;
    }
    .ig--detail {
        flex: none;
        box-sizing: border-box;
        padding: 30px;
        height: auto;
        @media (orientation: portrait) {
            display: flex;
            height: auto;
            background: none !important;
        }
        @media (orientation: landscape) {
            width: 340px;
        }
        .ig--poster {
            flex: none;
            width: 180px;
            height: 180px;
            margin-right: 20px;
            @media (orientation: landscape) {
                width: 280px;
                height: 280px;
            }
        }
        .ig--info {
            flex: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 6px 0;
            .ig--name {
                font-size: 32px;
                @media (orientation: landscape) {
                    padding: 20px 0;
                }
            }
            .ig--desc {
                font-size: 20px;
            }
            .ig--link {
                @media (orientation: landscape) {
                    padding-top: 36px;
                }
                > .item {
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    box-sizing: border-box;
                    width: 130px;
                    height: 46px;
                    border: 1px solid;
                    border-radius: 4px;
                    font-size: 18px;
                    color: inherit;
                }
                > .item:nth-child(n+2) {
                    margin-left: 20px;
                }
            }
        }
    }
    .ig--playbook {
        flex: auto;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .ig--tab {
            flex: none;
            display: flex;
            height: 66px;
            font-size: 28px;
            .ig--item {
                flex: auto;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                .ig--active {
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    width: 62px;
                    height: 4px;
                    transform: translate3d(-50%, 0, 0);
                }
            }
        }
        .ig--list {
            flex: auto;
            > .ig--title {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 20px 20px 0;
                font-size: 26px;
            }
            .ig--sort {
                display: flex;
                align-items: center;
                .ig--icon {
                    width: 34px;
                    height: 34px;
                    margin-left: 6px;
                }
            }
            iframe {
                width: 100%;
                min-height: 100%;
                height: 50vh;
            }
        }
    }
}
</style>
